import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "YearTotals" }


import { statuses } from "@/tools/status";
import StatusYearTotal from "@/components/pages/projects/year-totals/StatusYearTotal.vue";
import { FakeStatus } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'YearTotals',
  props: {
    year: {}
  },
  setup(__props: any) {



const totalStatus: FakeStatus = { id: -1, title: "Totaal" };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statuses), (status, index) => {
      return (_openBlock(), _createBlock(StatusYearTotal, {
        key: index,
        status: status,
        year: _ctx.year
      }, null, 8, ["status", "year"]))
    }), 128)),
    _createVNode(StatusYearTotal, {
      key: "total",
      status: totalStatus,
      year: _ctx.year,
      bold: ""
    }, null, 8, ["year"])
  ]))
}
}

})